import { useEffect, useState, type Dispatch, type SetStateAction } from 'react'

export function usePersistedState<T>(
  storageKey: string,
  fallback: T,
  parse: (raw: unknown) => T,
  start?: { value: T }
): [T, Dispatch<SetStateAction<T>>] {
  const [value, setValue] = useState<T>(() => {
    if (start !== undefined) return start.value
    if (typeof window === 'undefined') return fallback
    try {
      const raw = window.localStorage.getItem(storageKey)
      return raw === null ? fallback : parse(JSON.parse(raw))
    } catch {
      return fallback
    }
  })

  useEffect(() => {
    if (typeof window === 'undefined') return
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(value))
    } catch {}
  }, [storageKey, value])

  return [value, setValue]
}
